import React, { useState } from "react";

import { PageTitle } from "../../components/PageTitle";
import { useOrganizationContext } from "../../contexts/organizations/organizationsContext";
import { formatNumber } from "../../utils/NumbersFormatting";
import { RequestsExport } from "./components/RequestsExport/RequestsExport";
import { RequestsPage } from "./components/RequestsPage/RequestsPage";

const RequestsBreadcrumbs = [
  {
    title: "Monitoring & Insights",
    path: "",
    isSeparator: false,
    isActive: true,
  },
  {
    title: "",
    path: "",
    isSeparator: true,
    isActive: false,
  },
];

const RequestsWrapper = () => {
  const [requestsCount, setRequestsCount] = useState(0);

  const { currentOrganization } = useOrganizationContext();

  return (
    <>
      <div className="wrapper-header-export-btn-question-history">
        <PageTitle
          breadcrumbs={RequestsBreadcrumbs}
          breadcrumbTitle="Requests"
          pageTitle={`Requests ${
            requestsCount ? `(${formatNumber(requestsCount)})` : ""
          }`}
        />
        <div className="d-flex align-items-center position-relative w-350px justify-content-sm-end">
          {!!currentOrganization && (
            <RequestsExport organization={currentOrganization.id} />
          )}
        </div>
      </div>
      {!!currentOrganization && (
        <RequestsPage
          currentOrganization={currentOrganization}
          setRequestsCount={setRequestsCount}
        />
      )}
    </>
  );
};

export { RequestsWrapper };
